import { useEffect, useState } from 'react'

/**
 * Trails `value` by `delay` milliseconds.
 *
 * Used to keep a text field responsive while the thing it drives — a server
 * query — fires once the typing settles, rather than once per keystroke.
 */
export function useDebounced<T>(value: T, delay = 250): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(timer)
  }, [value, delay])

  return debounced
}
